import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { AuthUser } from 'common/auth/types';
import { UserSubType } from 'common/graphql/types';
import { find, includes } from 'lodash';
import { useUpdateActiveStudySiteWithRole } from './useUpdateActiveStudySiteWithRole';
import { CIPageStatus } from 'common/viewcomp/general/ci_pagestatus';
import { CILogger } from 'common/log/log.provider';
import { useTranslation } from 'react-i18next';

// TODO: should be a wrapper instead ? It's possible other navigation happens before this
// finishes the load
const useStudySiteQueryParamUpdate = (activeUser?: AuthUser) => {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation('global');
    const [updateActiveStudySite] = useUpdateActiveStudySiteWithRole();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const studyId = queryParams.get('studyId');
        const siteId = queryParams.get('siteId');

        if (
            studyId &&
            includes(
                [
                    UserSubType.SITE,
                    UserSubType.MONITOR,
                    UserSubType.DATA_MANAGER,
                    UserSubType.INSPECTOR,
                    UserSubType.PRODUCT_SUPPORT,
                    UserSubType.DATA_CHANGE_SUPPORT,
                ],
                activeUser?.subType as UserSubType
            )
        ) {
            const study = activeUser?.userStudies ? find(activeUser.userStudies, ['studyId', studyId]) : undefined;
            const site = siteId && study ? find(study.userStudySites, ['siteId', siteId]) : undefined;

            // Note: Url is handled differently later in the process if the study or site is not found.
            if (study && site) {
                // TODO: could be slow, so we should probably show loading state
                updateActiveStudySite({ study, site })
                    .then(() => {
                        queryParams.delete('studyId');
                        queryParams.delete('siteId');
                        const newSearch = queryParams.toString();
                        history.replace({
                            pathname: location.pathname,
                            search: newSearch.length > 0 ? `?${newSearch}` : '',
                        });
                    })
                    .catch((e) => {
                        CIPageStatus.error(t('switch_role.errors.updating_active_study_site'));
                        CILogger.getInstance().error(t('switch_role.errors.updating_active_study_site'), e);
                    });
            }
        }
    }, [location.search]);
};

export default useStudySiteQueryParamUpdate;
